import {
    useState,
    forwardRef,
    useImperativeHandle,
    useEffect,
    useContext,
} from "react"

import ExpandableComponentContext from "../../Contexts/ExpandableComponentContext"

const TextInput = forwardRef(({ title, description, validator, disabled, data, placeholder, isMandatory }, ref) => {

    const ExpandableComponentData = useContext(ExpandableComponentContext)

    const isInteracted = ExpandableComponentData ? ExpandableComponentData?.isInteracted : false

    const [value, setValue] = useState(data || "")
    const [error, setError] = useState(false)

    useEffect(() => {
        if (!data) {
            return
        }
        setValue(data)
    }, [data])

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            let validity = validator ? validator(value) : true
            if (isMandatory && !value) {
                validity = false
            }

            if (validity) {
                setError(false)
            }
            else {
                if (isInteracted) {
                    setError(true)
                }
            }

            return {
                isValid: validity,
                value,
            }
        },
        resetData: () => {
            setValue("")
        }
    }))

    return (
        <div className="my-2">
            {title && (
                <label className="block text-sm font-semibold text-gray-700 mb-2 text-left">
                    {title} {isMandatory ? <span className="text-red-500">*</span> : ""}
                </label>
            )}

            {description && (
                <p className="mt-1 text-xs text-gray-500">
                    {description}
                </p>
            )}

            <input
                type="text"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                disabled={disabled}
                placeholder={placeholder}
                autoComplete="new-password"
                className={`mt-1 mb-2 pr-10 pl-3 py-2 block w-full rounded-md border shadow-sm px-1 focus:ring-blue-500 focus:border-blue-500
                    ${error ? "border-red-500" : "border-gray-300"}`} />
            {error && (
                <p className="mt-1 text-sm text-red-600 ">
                    {title} is invalid
                </p>
            )}
        </div>
    )
})

export default TextInput
